'use client';

export const SwiperLink = ({ children, ...props }: any) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  <a
    {...props}
    onClick={(e) => {
      props['name'] === 'prev'
        ? SwipeHandler.prevSwipe(e.target)
        : SwipeHandler.nextSwipe(e.target);
    }}
  >
    {children}
  </a>
);

export default SwiperLink;
